import React from "react";
import styled from "styled-components";
import { education as educationData } from "../../data/constants";
import EducationCard from "../Cards/EducationCard";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 0 60px;

  @media (max-width: 960px) {
    padding: 0 0 40px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 40px 20px 0;
`;

const Title = styled.h2`
  font-size: 42px;
  text-align: center;
  font-weight: 700;
  margin: 20px 0 0;
  color: ${({ theme }) => theme.text_primary};

  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.p`
  font-size: 18px;
  text-align: center;
  max-width: 760px;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.7;
  margin: 0 0 10px;

  @media (max-width: 768px) {
    margin-top: 8px;
    font-size: 16px;
    max-width: 95%;
  }
`;

const Cards = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin-top: 10px;
  align-items: center;
`;

const Education = () => {
  return (
    <Container id="education">
      <Wrapper>
        <Title>Education</Title>
        <Desc>
          Academic background in software engineering, including undergraduate and graduate study focused on software development and systems engineering.
        </Desc>

        <Cards>
          {educationData.map((item) => (
            <EducationCard key={item.id} education={item} />
          ))}
        </Cards>
      </Wrapper>
    </Container>
  );
};

export default Education;
